import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { setupPage } from "./utils/pageSetup";

// Runs before React renders so the LCP image and fonts are discovered as early as possible.
setupPage();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-205" data-mp="26alpigfighyj" />);
}